import type { Currency } from "@anaconda/core/price/types"
import {
  Select,
  SelectTrigger,
  SelectValue,
} from "@rarible_int/anaconda_ui_components"

interface Props {
  currency: Currency
}

export function CurrencySelect({ currency }: Props) {
  return (
    <Select disabled>
      <SelectTrigger className="h-7 w-fit gap-1 rounded-md bg-muted py-1 pr-[4px] pl-2 text-xs uppercase">
        <SelectValue placeholder={currency.abbreviation} />
      </SelectTrigger>
    </Select>
  )
}
